import ApiClient from "./apiClient";
import { QueriesApi } from "./apiTypes";

const utilsService = {
  getActivityLog: (queries: Partial<QueriesApi> & Record<string, any> = {}) => {
    const {
      page,
      pageSize,
      page_size,
      ordering,
      ...rest
    } = queries || {};

    return ApiClient.get("activitylog", {
      params: {
        page,
        ordering,
        page_size: pageSize ?? page_size,
        ...rest,
      },
    });
  },
  getReports: (queries: Partial<QueriesApi> = {}) => {
    const {
      page,
      pageSize,
      page_size,
      ordering,
      ...rest
    } = queries || {};

    return ApiClient.get("reports/estimated-instance-revenue/get_report_for_region", {
      params: {
        page,
        ordering,
        page_size: pageSize ?? page_size,
        region_name:'default',
        ...rest,
      },
    });
  },
  getEmailMessageLog: (queries: Partial<QueriesApi> = {}) => {
    const {
      page,
      pageSize,
      page_size,
      ordering,
      ...rest
    } = queries || {};

    return ApiClient.get("logger/email-message-log", {
      params: {
        page,
        ordering,
        page_size: pageSize ?? page_size,
        ...rest,
      },
    });
  },
  getEmailMessageLogEntry: (
    id: number | string,
    params: Record<string, any> = {}
  ) =>
    ApiClient.get(`logger/email-message-log/${id}`, {
      params,
    }),
  getPeriodicTaskLog: (queries: Partial<QueriesApi> = {}) => {
    const { page, pageSize, page_size, ordering, ...rest } = queries || {};

    return ApiClient.get("tasklog", {
      params: {
        page,
        ordering,
        page_size: pageSize ?? page_size,
        ...rest,
      },
    });
  },
  recreatePeriodicTaskLog: (
    id: number | string,
    payload: Record<string, any> = {}
  ) => ApiClient.post(`tasklog/${id}/recreate`, payload),
  getTasksForActivity: (params: Record<string, any> = {}) =>
    ApiClient.get("tasklog/get_tasks_for_activity", {
      params,
    }),
  getTaskLog: (
    id: number | string,
    params: Record<string, any> = {}
  ) =>
    ApiClient.get(`tasklog/${id}/get_task_log`, {
      params,
    }),
  loadTaskLog: (
    id: number | string,
    params: Record<string, any> = {}
  ) =>
    ApiClient.get(`tasklog/${id}/load_task_log`, {
      params,
    }),
  downloadTaskLog: (
    id: number | string,
    params: Record<string, any> = {}
  ) =>
    ApiClient.get(`tasklog/${id}/download_task_log`, {
      params,
      responseType: "blob",
    }),
};

export default utilsService;
